/**
 * Liquid Glass (docs/liquid-glass-ab-research.md, docs/retire-variant-a-plan.md).
 *
 * Glass is the only design, but `data-ui="glass"` on <html> still marks the
 * signed-in app apart from the customer's pages (a quote, a pay page, a booking
 * page), which must never look like the app: 5,000-odd `:root[data-ui="glass"]`
 * rules hang off it. It has to be <html>, not the shell: the bottom bar
 * (MobileNav) is mounted in the ROOT layout, outside AuthedShell, so nothing
 * inside the shell can scope it.
 *
 * The root layout cannot tell the app from a customer's page, so the marker
 * also lives in a cookie: AuthedShell writes it, and the next request paints
 * the attribute from byte zero instead of flashing the unstyled bar for a frame.
 *
 * Directive-free on purpose: the server layout and a client effect both import
 * from here (anti-pattern #18).
 */
export const UI_VARIANT_COOKIE = 'mucka_ui';
export const UI_GLASS = 'glass';

/** Browser only. Sets or clears the attribute and remembers the choice. */
export function applyUiVariant(glass: boolean): void {
  const root = document.documentElement;
  if (glass) root.dataset.ui = UI_GLASS;
  else delete root.dataset.ui;
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = glass
    ? `${UI_VARIANT_COOKIE}=${UI_GLASS}; Path=/; Max-Age=34560000; SameSite=Lax${secure}`
    : `${UI_VARIANT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}

/**
 * The native glass bar trial (PR 4, docs/liquid-glass-native-bar-plan.md) —
 * `accounts.ui_glass_native`, as `data-ui-native` on <html> beside `data-ui`.
 * No cookie: an app that opens on the web glass bar and swaps to the native
 * one a moment later is acceptable for a trial picked by hand, and a stale
 * cookie that drew a native bar for an account just switched off is not.
 */
export const UI_NATIVE_ATTR = 'uiNative';

/** Browser only. */
export function applyUiNative(on: boolean): void {
  const root = document.documentElement;
  if (on) root.dataset[UI_NATIVE_ATTR] = '1';
  else delete root.dataset[UI_NATIVE_ATTR];
}
